<template>
  <EmailGroupSend />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
